import styled from 'styled-components'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { NATIVE } from '@donaswap/sdk'
import Link from 'next/link'
import { NetworkAlertChains } from '../NetworkAlert/ShouldShowAlert'
import { DocsIcon, BoxProps } from '@donaswap/uikit'

const RootWrapper = styled.div<{ chainId: NetworkAlertChains }>`
  color: ${({ theme }) => theme.colors.textSubtle};
`

export function NetworkDocsAlert({ color }: Pick<BoxProps, 'color'>) {
  const { chainId } = useActiveChainId()

  const { docs } = NATIVE[chainId]

  return docs ? (
    <RootWrapper chainId={chainId} >
      <Link href={docs} target="_blank">
        <DocsIcon width={22} height={22} color={color} marginTop={1}/>
      </Link>
    </RootWrapper>
  ) : null
}
